var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2377_155)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_155",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_155)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2377_155",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2377_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0032 7.84423L13.3744 13.3642L13.5586 16.1386C13.5606 16.4239 13.6053 16.7074 13.6916 16.9798C13.9141 17.5086 14.4496 17.8446 15.0321 17.8211L23.9084 17.2404C24.2928 17.2342 24.664 17.3779 24.9402 17.6402C25.1705 17.8587 25.3192 18.1446 25.3661 18.452L25.3818 18.6387C25.0145 23.725 21.2789 27.9674 16.2032 29.0624C11.1274 30.1575 5.92248 27.8442 3.41428 23.3783C2.69119 22.0808 2.23953 20.6548 2.08584 19.1838C2.02164 18.7483 1.99337 18.3084 2.00131 17.8684C1.99337 12.4154 5.87663 7.70106 11.3124 6.56454C11.9667 6.46266 12.608 6.80901 12.8704 7.40582C12.9382 7.54403 12.983 7.69206 13.0032 7.84423Z",
    fill: "#2B2B67"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.3327 13.0824L29.3234 13.1259L29.2965 13.1891L29.3002 13.3626C29.2863 13.5923 29.1975 13.8134 29.0447 13.992C28.8854 14.178 28.6678 14.3047 28.4282 14.3539L28.2821 14.3739L18.041 15.0375C17.7003 15.0711 17.3611 14.9612 17.1079 14.7354C16.8967 14.547 16.7618 14.2928 16.7237 14.019L16.0363 3.79276C16.0243 3.75819 16.0243 3.72071 16.0363 3.68612C16.0457 3.40424 16.1698 3.1378 16.3809 2.94632C16.5918 2.75484 16.8723 2.65428 17.1594 2.66711C23.2393 2.82179 28.3491 7.19374 29.3327 13.0824Z",
    fill: "#2B2B67"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2377_155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.bb3d790118c3c74cce85adc31a03bfca.svg";
export { ForwardRef as ReactComponent };